import React from 'react';
import { Wrench } from 'lucide-react';
export function Process() {
  const steps = [{
    title: 'Request Your Free In-Home Quote',
    copy: "Submit the short form or call Kosin's Glass."
  }, {
    title: 'Share Photos & Basic Details',
    copy: 'A team member will ask about your bathroom layout, existing shower or tub opening, project timeline, rough measurements and style preferences.'
  }, {
    title: 'In-Home Consultation & Samples',
    copy: "Kosin's Glass can come to your home, review the space, show samples, discuss glass options and recommend the right enclosure style."
  }, {
    title: 'Exact Measurements & Firm Quote',
    copy: 'Exact measurements are taken before fabrication. Your final quote should reflect the measurements, glass selection, hardware finish and installation requirements.'
  }, {
    title: 'Fabrication & Professional Installation',
    copy: 'Your custom shower glass is prepared, then installed by experienced glass technicians with attention to fit, finish, function and long-term appearance.'
  }];
  return <section className="py-20 bg-glass" data-id="element-1450" data-mp="2k69uawpc342g">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-1451" data-mp="2k9p87w79u72a">
        <div className="text-center max-w-3xl mx-auto mb-16 anim-on-scroll" data-id="element-1452" data-mp="2y5syxfixrxa0">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-6 tracking-normal" data-id="element-1453" data-mp="2u4z8aee404df">
            How Your Custom Shower Door Quote Works
          </h2>
        </div>
        <div className="grid lg:grid-cols-12 gap-12 items-start" data-id="element-1454" data-mp="26dk7wr5w7x4t">
          <div className="lg:col-span-8" data-id="element-1455" data-mp="21iellr8kwgg7">
            <div className="space-y-8" data-id="element-1456" data-mp="2f7zvmc4ehlc3">
              {steps.map((step, i) => <div key={i} className="flex gap-6 bg-white p-6 rounded-lg shadow-sm border border-blue-50 scroll-fade-up" style={{
              animationDelay: `${i * 0.1}s`
            }} data-id="element-1457" data-mp="2fa2xbtex12wn" data-mpi={i}>
                  <div className="w-12 h-12 shrink-0 bg-primary text-white rounded-full flex items-center justify-center text-xl font-bold" data-id="element-1458" data-mp="1iq3m87d4v0mu">
                    {i + 1}
                  </div>
                  <div data-id="element-1459" data-mp="3msm0e84e2e5g">
                    <h3 className="text-xl font-bold text-navy mb-2" data-id="element-1460" data-mp="3mru2urr8e6cj">
                      {step.title}
                    </h3>
                    <p className="text-gray-600" data-id="element-1461" data-mp="f5a6blcqnb7">{step.copy}</p>
                  </div>
                </div>)}
            </div>
          </div>
          <div className="lg:col-span-4" data-id="element-1462" data-mp="2yyc9cbmkfpuz">
            <div className="bg-navy text-white p-8 rounded-lg sticky top-8 scroll-fade-up" data-id="element-1463" data-mp="33usxh5trm482">
              <h4 className="text-xl font-bold mb-4 flex items-center gap-2" data-id="element-1464" data-mp="38up3tbpxq7qs">
                <Wrench className="w-6 h-6 text-primary" data-id="element-1465" data-mp="38wrxq6u7kl0s" />
                Remodeling tip
              </h4>
              <p className="text-blue-100 leading-relaxed" data-id="element-1466" data-mp="o46m48te8gl8">
                If your bathroom is being remodeled, contact Kosin's Glass early
                for planning help. Final shower glass measurements are typically
                best after tile, walls and curb details are complete.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}